var parts = ['container', 'value', 'label'];
var baseStyle = {
  container: {
    layerStyle: 'card',
    alignItems: 'center',
    flex: '1 1 0',
    py: 2,
    px: 3,
    textStyle: 'text'
  },
  value: {
    fontSize: '2xl',
    fontWeight: 'semibold'
  },
  label: {
    fontSize: 'sm',
    fontWeight: 'normal',
    lineHeight: 'none'
  }
};
var StatisticsCard = {
  baseStyle: baseStyle,
  parts: parts
};
export { StatisticsCard as default };